export function getCookie(cookieName: string): string {
	const regex = new RegExp('(?:^|; )' + cookieName.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)');
	const matches: RegExpExecArray | null = regex.exec(document.cookie);
	return matches ? decodeURIComponent(matches[1]) : '';
}
